import { AxiosError } from 'axios'
import SERVER_ERROR_NAME from '../Constants/ServerErrorName'

const isServerError = (error: unknown | AxiosError): error is AxiosError => {
    return (error as AxiosError).name === SERVER_ERROR_NAME
}

export default isServerError
